import {
  AlertOutlined,
  FireOutlined,
  GlobalOutlined,
  StarOutlined,
  TeamOutlined,
} from "@ant-design/icons";

import { ITableLayoutFieldManager } from "@defs/layout-manager";

export interface TicketsConfig {
  layoutManager: ITableLayoutFieldManager[];
  types: {
    value: string;
    icon?: any;
  }[];
}

const ticketsConfig: TicketsConfig = {
  layoutManager: [
    {
      key: "progressivo",
      active: true,
      align: "center",
      removable: true,
    },
    {
      key: "priorita",
      active: true,
      align: "center",
      removable: false,
    },
    {
      key: "pubblico",
      active: true,
      align: "center",
      removable: true,
    },
    {
      key: "tag",
      active: true,
      align: "center",
      removable: true,
    },
    {
      key: "assegnatari",
      active: true,
      align: "center",
      removable: true,
    },
    {
      key: "titolo",
      active: true,
      align: "left",
      removable: false,
    },
    {
      key: "nome_cliente",
      active: true,
      align: "left",
      removable: true,
    },
    {
      key: "handle",
      active: true,
      align: "left",
      removable: true,
    },
    {
      key: "resolve",
      active: true,
      align: "left",
      removable: true,
    },
    {
      key: "timings",
      active: true,
      align: "left",
      removable: true,
    },
    {
      key: "scadenza",
      active: true,
      align: "left",
      removable: false,
    },
    {
      key: "status",
      active: true,
      align: "center",
      removable: true,
    },
    {
      key: "categoria",
      active: true,
      align: "left",
      removable: true,
    },
    {
      key: "proprietario",
      active: true,
      align: "center",
      removable: true,
    },
    {
      key: "data_creazione",
      active: true,
      align: "left",
      removable: true,
    },
  ],

  types: [
    {
      value: "user",
      icon: FireOutlined,
    },
    {
      value: "assignee",
      icon: TeamOutlined,
    },
    {
      value: "open",
      icon: AlertOutlined,
    },
    {
      value: "public",
      icon: GlobalOutlined,
    },
    {
      value: "favorites",
      icon: StarOutlined,
    },
    {
      value: "owner",
    },
    {
      value: "observer",
    },
    {
      value: "public-not-handled",
    },
    {
      value: "all",
    },
    {
      value: "my-groups",
    },
  ],
};

export default ticketsConfig;
